import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconWorld from '@/icons/World.svg';
import { TYPES } from '@/models/entity';

import { useFilters } from '../FiltersState';

export const FiltersType = () => {
  const { t, i18n } = useLingui();

  const {
    types: { types, setTypes },
  } = useFilters();

  const toggleType = (type: (typeof types)[number]) => {
    if (types.includes(type)) {
      setTypes(types.filter((t) => t !== type));
    } else {
      setTypes([...types, type]);
    }
  };

  const options = TYPES.map(({ id, label }) => (
    <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
  ));

  return (
    <FiltersSubMenu
      id="type"
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.entities.entities.filters.type.label',
        message: 'Type',
      })}
      count={types.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.entities.entities.filters.type.label',
          message: 'Type',
        })}
        values={types}
        onChange={toggleType}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
